"use client";
import { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

// Toolbar configuration
const modules = {
  toolbar: [
    [{ font: [] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"], // clear formatting
  ],
};

const formats = [
  "font",
  "bold", "italic", "underline", "strike",
  "list", "bullet",
  "link",
];

interface EditorProps {
  value?: string;
  onChange?: (content: string) => void;
  placeholder?: string;
}

export default function Editor({
  value = "",
  onChange,
  placeholder = "Start writing here...",
}: EditorProps) {
  const [content, setContent] = useState(value);

  // Update internal state when value prop changes
  useEffect(() => {
    setContent(value);
  }, [value]);

  const handleChange = (val: string) => {
    setContent(val);
    if (onChange) onChange(val); // lift state up if parent passes handler
  };

  return (
    <div className="">
      <ReactQuill
        theme="snow"
        value={content}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        style={{ height: "250px" }}
      />
    
    </div>
  );
}
